module.exports = __webpack_public_path__ + "img/web_wenz01.8ba91652.png";